import { getField, updateField } from 'vuex-map-fields';
export default {
  namespaced: true,
  state: {
    bookingID: '',
    isInputActive: false,
    panelActive: 0,
  },
  getters: {
    getField,
  },
  mutations: {
    updateField,
  },
  actions: {

  }
};